
class Util {

    static setFolowAnimationFromBone (dist,track,key){
      
      dist[key+"PerFrame"] = track;

      dist[key+"PerFrameFunc"] = async function(obj,_frame){
        let frame;
        
        if(obj && obj[key+"PerFrame"] && obj[key+"PerFrame"].length > 1){

          
          
          // console.log(obj[key+"PerFrame"])
          if(key == "quaternion"){
            frame = _frame*4;
            frame %= obj[key+"PerFrame"].length;
            obj[key].set(obj[key+"PerFrame"][frame],obj[key+"PerFrame"][frame+1],obj[key+"PerFrame"][frame+2],obj[key+"PerFrame"][frame+3])
          }
          if(key == "position" || key == "scale")
          {
            frame = _frame*3;
            frame %= obj[key+"PerFrame"].length;
            obj[key].set(obj[key+"PerFrame"][frame]*10,obj[key+"PerFrame"][frame+1]*10,obj[key+"PerFrame"][frame+2]*10)
          }
          if(key == "scale")
          {
            frame = _frame*3;
            frame %= obj[key+"PerFrame"].length;
            obj[key].set(obj[key+"PerFrame"][frame],obj[key+"PerFrame"][frame+1],obj[key+"PerFrame"][frame+2])
          }
          
        
          
          
          
        }
      }
      dist["PerFrameFunctions"].push(dist[key+"PerFrameFunc"]);
    }

    static setFromConfig (dist,from) {
      
        if(from){
            dist["PerFrameFunctions"] = [];
            for (const key in from) {
              if(!Array.isArray(from[key])){
                dist[key] = from[key];
                continue;
              }
                if(from[key][0].val.length == 3){
                    
                    if( key != "color"){
                      dist[key].set(from[key][0].val[0],from[key][0].val[1],from[key][0].val[2])
                    }else{
                      if(from[key][0].format && from[key][0].format == "HSL"){
                        dist[key].setHSL(from[key][0].val[0],from[key][0].val[1],from[key][0].val[2])
                      }else{
                        dist[key].setRGB(from[key][0].val[0],from[key][0].val[1],from[key][0].val[2])
                      }
                      
                    }
                    
                  
                }else{
                    dist[key] = from[key][0].val[0];
                }
                dist[key+"PerFrame"] = acumulateLerps(from[key]);

                dist[key+"PerFrameFunc"] = async function(obj,frame){
                  if(obj && obj[key+"PerFrame"] && obj[key+"PerFrame"].length > 1){
                    if(obj[key+"PerFrame"].length <= frame){
                      frame = obj[key+"PerFrame"].length -1
                    }
                    
                    if(from[key][0].val.length == 3 ){
                      if(key != "color"){
                        obj[key].set(obj[key+"PerFrame"][frame][0],obj[key+"PerFrame"][frame][1],obj[key+"PerFrame"][frame][2])
                      }else{
                        if(from[key][0].format && from[key][0].format == "HSL"){
                          obj[key].setHSL(obj[key+"PerFrame"][frame][0],obj[key+"PerFrame"][frame][1],obj[key+"PerFrame"][frame][2])
                        }else{
                          obj[key].setRGB(obj[key+"PerFrame"][frame][0],obj[key+"PerFrame"][frame][1],obj[key+"PerFrame"][frame][2])
                        }
                        
                      }
                      
                    }else{
                      obj[key] = obj[key+"PerFrame"][frame][0];
                    }
                    
                    
                    
                  }
                }
                dist["PerFrameFunctions"].push(dist[key+"PerFrameFunc"]);
            }
          }
          return dist
    }
  
  }
  function generateLerpArray(from , to , array_size){
    const resGLA= []
    if(array_size <= 0 ||  !from || !to || from.length != to.length ) return resGLA
    let div_arr = []
    for( var i = 0; i < from.length;i++ ){
      div_arr.push((to[i]-from[i])/array_size)
      
    }
    resGLA.push(from)
    for(var i = 0; i < array_size-1;i++){
      let vec = []
      for(var j = 0; j < from.length;j++){
        vec.push(resGLA[i][j] + div_arr[j])
      }
        
      resGLA.push(vec)
    }
    resGLA.push(to)
    return resGLA

  }
  function acumulateLerps(lerp_arr){
    if(lerp_arr.length <= 1) return null
    let resAL = []
    for(var i=0 ; i < lerp_arr.length -1 ; i++){
      resAL = [...resAL,...generateLerpArray(lerp_arr[i].val,lerp_arr[i+1].val,lerp_arr[i+1].frame - lerp_arr[i].frame) ]
    }
    return resAL
  }
  export default Util;